import { loaders } from 'entities';

import { useUrlStateV2 } from 'hooks';

import ParamsError from './ParamsError';
import Validating from './Validating';
import ValidationError from './ValidationError';
import DownloadNew from './DownloadNew';
import Success from './Success';

function ValidateProjectPDF() {
  const [params] = useUrlStateV2<{ c?: string }>();

  const code = params.c;

  const validation = loaders.projects.validatePDF.use({
    params: { code: `${code}` },

    blockLoad: !code,
  });

  if (!code) return <ParamsError />;

  if (validation.loading) return <Validating />;

  if (validation.error) return <ValidationError />;

  if (validation.data?.valid) return <Success />;

  return <DownloadNew code={validation.data?.lastValidCode as string} />;
}

function WithWrapper(Component: typeof ValidateProjectPDF): () => JSX.Element {
  function Decorated(): JSX.Element {
    return (
      <div className="flex h-[100vh] items-center justify-center bg-primary px-5 phone:px-3 small_phone:px-2">
        <div className="phones:p-6 w-full max-w-xl rounded-lg bg-background p-8 text-center">
          <Component />
        </div>
      </div>
    );
  }

  return Decorated;
}

export default WithWrapper(ValidateProjectPDF);
